export type EmojiMartCategory = {
  id: string
  name: string
  emojis: string[]
}

export type EmojiMartEmoji = {
  id: string
  name?: string
  keywords?: string[]
  skins?: { native?: string }[]
}

export type EmojiMartData = {
  categories: EmojiMartCategory[]
  emojis: Record<string, EmojiMartEmoji>
}

let cachedData: EmojiMartData | null = null
let cachedPromise: Promise<EmojiMartData> | null = null

export async function loadEmojiMartData(): Promise<EmojiMartData> {
  if (cachedData) return cachedData
  if (cachedPromise) return cachedPromise

  cachedPromise = (async () => {
    const mod: any = await import('@emoji-mart/data')
    const data: EmojiMartData = (mod?.default || mod) as any
    cachedData = data
    return data
  })()

  return cachedPromise
}

export function getEmojiNative(data: EmojiMartData, emojiId: string): string | null {
  const entry = data?.emojis?.[emojiId]
  const native = entry?.skins?.[0]?.native
  return typeof native === 'string' && native.trim() ? native : null
}

export function searchEmojis(
  data: EmojiMartData,
  query: string,
  max = 120,
): string[] {
  const raw = String(query || '').trim().toLowerCase()
  if (!raw) return []

  const result: string[] = []
  const seen = new Set<string>()

  const push = (id: string) => {
    if (!id || seen.has(id)) return
    seen.add(id)
    result.push(id)
  }

  const all = data?.emojis ? Object.values(data.emojis) : []
  for (const emoji of all) {
    if (!emoji?.id) continue
    if (result.length >= max) break

    const id = String(emoji.id).toLowerCase()
    const name = String(emoji.name || '').toLowerCase()
    const keywords = Array.isArray(emoji.keywords)
      ? emoji.keywords.map((k) => String(k || '').toLowerCase())
      : []

    if (
      id.includes(raw) ||
      name.includes(raw) ||
      keywords.some((k) => k.includes(raw))
    ) {
      push(emoji.id)
    }
  }

  return result
}

